import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Alert, Form, Icon, Input } from 'antd'
import querystring from 'querystring'
import { infoRequired, validatePassword } from '../../utils/validators';
import { request } from '../../utils/api';
import TagFlow from '../../Components/TagFlow';
import Navbar from '../../Components/Navbar';
import Footer from '../../Components/Footer'
import CookieConsentComponent from '../../Components/CookieConsent'
import './reset.css';
import theme from '../../config/theme';
class ResetPassword extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: null,
            message: '',
            success: false,
            query: {},
            queryWallet: {},
            fillBackground: false
        }
    }

    componentDidMount() {
        const query = querystring.parse(this.props.location.search.replace('?', ''))
        this.setState({
            query: {
                hash: query.q,
                email: query.e,
                time: query.t,
                userid: query.u
            },
            queryWallet: {
                token: query.token,
                platform: query.platform,
                email: query.email,
                username: query.username,
                type: query.type
            }
        })
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
    }

    handleSuccess = () => {
        this.setState({
            success: true,
            loading: false,
            message: ''
        })
    }

    handleSubmit = e => {
        e.preventDefault()
        this.props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                this.setState({ loading: true })
                try {
                    const response = await request('users/reset-password', 'PUT', {
                        id: this.state.query.userid,
                        time: this.state.query.time,
                        hash: this.state.query.hash,
                        email: this.state.query.email || this.state.queryWallet.email,
                        token: this.state.queryWallet.token,
                        platform: this.state.queryWallet.platform,
                        username: this.state.queryWallet.username,
                        senhaNova: values.novaSenha,
                        type: this.state.queryWallet.type
                    })
                    if (response.code === 200) {
                        this.handleSuccess()
                    } else {
                        this.setState({
                            loading: false,
                            message: response.message || 'Ops! Não conseguimos alterar sua senha no momento!'
                        })
                    }
                } catch(e) {
                    this.setState({
                        loading: false,
                        message: 'Ops! Não conseguimos alterar sua senha no momento!'
                    })
                }
            }
        })
    }

    handleWindowScroll = () => {
        this.setState({
            fillBackground: window.scrollY > 100
        })
    }

    render() {
        const { form } = this.props
        return (
            <div id="sectionPass">
                <Navbar fillBackground={this.state.fillBackground} />
                <div className="signupWrapper">

                </div>
                <div style={{ paddingTop: 50, maxWidth: 700, margin: 'auto' }}>
                    {this.state.success ? (
                        <div className="senhaSuccess animated bounceInRight loginWrapper d-flex align-items-center">
                            <div className='d-flex flex-column align-items-center'>
                                <h2 className='text-white'>Senha alterada!</h2>
                                <h4 className='text-white text-center mt-3'>Você já pode utilizar sua nova senha para acessar sua conta no <TagFlow /></h4>
                                <Link to="/login" className="anchorBtn mt-3">Acessar conta</Link>
                            </div>
                        </div>
                    ) : (
                        <div className="animated fadeIn loginWrapper">
                            <img alt={`Logo ${process.env.REACT_APP_NAME}`} src={theme.logos.default} className="img-fluid" />
                            <h6 className="subTitle text-white text-center">Altere sua senha</h6>
                            <Form layout="vertical" onSubmit={this.handleSubmit}>
                                {this.state.message && <Form.Item>
                                    <Alert message={this.state.message} type="error" showIcon />
                                </Form.Item>}

                                <div style={{ textAlign: 'center' }}>
                                    {this.state.loading && <Form.Item>
                                        <Icon type="loading" />
                                    </Form.Item>}
                                </div>

                                <Form.Item label={<span style={{ color: 'white' }}>E-mail</span>}>
                                    {form.getFieldDecorator('email', { initialValue: this.state.query.email || this.state.queryWallet.email })(
                                        <Input disabled style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', color: 'white', borderColor: 'var(--theme-border)' }} />
                                    )}
                                </Form.Item>

                                <Form.Item label={<span style={{ color: 'white' }}>Nova Senha</span>}>
                                    {form.getFieldDecorator('novaSenha', {
                                        rules: [
                                            infoRequired,
                                            validatePassword()
                                        ]
                                    })(
                                        <Input.Password placeholder="Senha" style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', borderColor: 'var(--theme-border)' }} />
                                    )}
                                </Form.Item>

                                <Form.Item label={<span style={{ color: 'white' }}>Confirme sua nova senha</span>}>
                                    {form.getFieldDecorator('confirmSenha', {
                                        rules: [
                                            {
                                                validator: (_, value, callback) => {
                                                    if (value && value !== form.getFieldValue('novaSenha')) {
                                                        callback('As senhas não correspondem')
                                                    } else {
                                                        callback()
                                                    }
                                                }
                                            }
                                        ]
                                    })(
                                        <Input.Password placeholder="Confirme sua nova senha" style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', borderColor: 'var(--theme-border)' }} />
                                    )}
                                </Form.Item>

                                <Form.Item>
                                    <button type="submit" className="alterarSenhaSubmit">
                                        Alterar Senha
                                    </button>
                                </Form.Item>
                            </Form>
                        </div>
                    )}
                </div>
                <CookieConsentComponent />
                <Footer />
            </div>
        )
    }
}

export default Form.create({ name: 'reset-password' })(ResetPassword)